'use client';

import { IconCard } from '@actr/icons/card';
import { IconClock } from '@actr/icons/clock';
import { IconPlaneDeparture } from '@actr/icons/plane-departure';
import { Text } from '@actr/ui/src/components/_atoms/text';
import { ContentBlock } from '@actr/ui/src/components/content-block';
import { Price } from '@actr/ui/src/components/price';
import { observer } from 'mobx-react-lite';
import React from 'react';

import * as Styled from './style.css';

export type FlightInformationProps = {
    flight_information: {
        title: string;
        list: {
          average_flight_time: string;
          high_price: number;
          low_price: number;
          earliest_departure: string;
          latest_departure: string;
        } | null;
    };
}

const FlightInformation: React.FC<FlightInformationProps> = ({ flight_information }) => (
  <ContentBlock
    className={Styled.ContentBlock}
    id="flight_information"
    tagProps={{ itemScope: true, itemType: 'https://schema.org/Flight' }}>
    <Text className={Styled.Title} tagName="h3" font="title.x2l" tagProps={{ itemProp: 'name' }}>{flight_information.title}</Text>
    <div className={Styled.MainInfo}>
      <div className={Styled.InfoWrapper}>
        <IconClock className={Styled.Icon} />
        <div className={Styled.InfoContent}>
          <Text
            font="paragraph.m.semi"
            tagProps={{
              itemProp: 'estimatedFlightDuration',
              dateTime: flight_information?.list?.average_flight_time ?? ''
            }}>
            {flight_information?.list?.average_flight_time}
          </Text>
          <Text font="paragraph.s">Среднее время перелета</Text>
        </div>
      </div>
      <div
        className={Styled.InfoWrapper}
        itemScope
        itemType="https://schema.org/AggregateOffer">
        <IconCard className={Styled.Icon} />
        <div className={Styled.InfoContent}>
          <Price
            className={Styled.Amount}
            font="paragraph.m.semi"
            amount={flight_information?.list?.high_price || 0}
            tagProps={{
              itemProp: 'highPrice',
              content: (flight_information?.list?.high_price || 0).toString()
            }}
          />
          <Text font="paragraph.s">Самая высокая цена</Text>
        </div>
      </div>
      <div
        className={Styled.InfoWrapper}
        itemScope
        itemType="https://schema.org/AggregateOffer">
        <IconCard className={Styled.Icon} />
        <div
          className={Styled.InfoContent}>
          <Price
            className={Styled.Amount}
            font="paragraph.m.semi"
            amount={flight_information?.list?.low_price || 0}
            tagProps={{
              itemProp: 'lowPrice',
              content: (flight_information?.list?.low_price || 0).toString()
            }}
          />
          <Text font="paragraph.s">Самая низкая цена</Text>
        </div>
      </div>
      <div className={Styled.InfoWrapper}>
        <IconPlaneDeparture className={Styled.Icon} />
        <div className={Styled.InfoContent}>
          <Text
            font="paragraph.m.semi"
            tagProps={{
              itemProp: 'departureTime',
              dateTime: flight_information?.list?.earliest_departure
            }}>
            {flight_information?.list?.earliest_departure}
          </Text>
          <Text font="paragraph.s">Самый ранний вылет из города</Text>
        </div>
      </div>
      <div className={Styled.InfoWrapper}>
        <IconPlaneDeparture className={Styled.Icon} />
        <div className={Styled.InfoContent}>
          <Text
            font="paragraph.m.semi"
            tagProps={{
              itemProp: 'departureTime',
              dateTime: flight_information?.list?.latest_departure
            }}>
            {flight_information?.list?.latest_departure}
          </Text>
          <Text font="paragraph.s">Самый поздний вылет из города</Text>
        </div>
      </div>
    </div>
  </ContentBlock>
);

export default observer(FlightInformation);
